import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DataIntegrationBasicDetail from "./dataIntegrationComponents/DataIntegrationBasicDetail";


import { useGetDataIntegrationDetailQuery } from "store/services/dataIntegrationApi";

import {
  DataIntegrationDetailContext,
  useDataIntegrationDetailContext,
} from "contexts/DataIntegrationDetailContext";

const DataIntegrationDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Data Integrations", path: "/app/crm/dataIntegration/list" },
    { title: "Data Integration Detail" },
  ];

  // RTK Query
  const {
    data: dataIntegrationDetail,
    isLoading: loadingDataIntegration,
    error,
  } = useGetDataIntegrationDetailQuery(id);

  return (
    <DataIntegrationDetailContext.Provider
      value={{ dataIntegrationDetail, loadingDataIntegration }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingDataIntegration}
        toggleKey="DATA_INTEGRATION_DETAIL"
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
        <DataIntegrationBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </DataIntegrationDetailContext.Provider>
  );
};

export default DataIntegrationDetailScreen;

const PageActions = () => {
  const { dataIntegrationDetail } = useDataIntegrationDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/dataIntegration/${dataIntegrationDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
